// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_table_container {
  margin-top: 25px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 22px;
  box-shadow: 0 6px 24px rgba(15, 23, 42, .06);
  animation: e2eTableFade .3s ease both;
}

.e2e_table_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e2e8f0;
}

.e2e_table_header h3 {
  margin: 2px 0 4px;
  color: #172033;
  font-size: 25px;
  font-weight: 800;
}

.e2e_table_header span,
.e2e_table_eyebrow {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.e2e_table_eyebrow {
  color: #2563eb;
  text-transform: uppercase;
  letter-spacing: .08em;
}

.e2e_table_actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 9px;
}

.e2e_table_actions button,
.e2e_table_state button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 13px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  font-weight: 700;
  cursor: pointer;
  transition: .2s ease;
}

.e2e_table_actions button:hover,
.e2e_table_state button:hover {
  border-color: #2563eb;
  color: #2563eb;
  transform: translateY(-1px);
}

.e2e_table_actions button:disabled {
  opacity: .55;
  cursor: wait;
}

.e2e_table_toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.e2e_table_search {
  display: flex;
  align-items: center;
  gap: 10px;
  width: min(520px, 100%);
  padding: 0 14px;
  border: 1px solid #dbe3ef;
  border-radius: 12px;
  color: #64748b;
  background: #f8fafc;
}

.e2e_table_search:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, .1);
  background: #fff;
}

.e2e_table_search input {
  width: 100%;
  padding: 12px 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #172033;
}

.e2e_table_limit {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.e2e_table_limit select {
  padding: 9px;
  border: 1px solid #dbe3ef;
  border-radius: 9px;
  background: #fff;
}

.e2e_table_loading_label {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 12px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.e2e_table_loading_label span {
  width: 16px;
  height: 16px;
  border: 2px solid #bfdbfe;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: e2eSpin .75s linear infinite;
}

.e2e_table_scroll {
  max-height: 620px;
  overflow: auto;
  border: 1px solid #edf1f6;
  border-radius: 14px;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}

.e2e_dashboard_table {
  width: 100%;
  min-width: 1100px;
  border-collapse: separate;
  border-spacing: 0;
}

.e2e_dashboard_table thead {
  position: sticky;
  z-index: 2;
  top: 0;
  background: #f5f8fc;
}

.e2e_dashboard_table th {
  padding: 14px 16px;
  border-bottom: 1px solid #dfe7f1;
  color: #475569;
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .055em;
  white-space: nowrap;
}

.e2e_sort_button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  cursor: pointer;
}

.e2e_sort_button svg {
  color: #94a3b8;
}

.e2e_dashboard_table td {
  max-width: 260px;
  padding: 15px 16px;
  border-bottom: 1px solid #eef2f7;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e2e_candidate_report_link {
  max-width:100%;
  padding:0;
  overflow:hidden;
  border:0;
  background:transparent;
  color:#2563eb;
  font:inherit;
  font-weight:800;
  text-align:left;
  text-overflow:ellipsis;
  white-space:nowrap;
  cursor:pointer;
}
.e2e_candidate_report_link:hover,.e2e_candidate_report_link:focus-visible{color:#4338ca;text-decoration:underline;outline:none}

.e2e_dashboard_table tbody tr:nth-child(even) {
  background: #fafcff;
}

.e2e_dashboard_table tbody tr {
  transition: background .18s ease, transform .18s ease;
}

.e2e_dashboard_table tbody tr:hover {
  background: #eef6ff;
}

.e2e_action_buttons {
  display: flex;
  align-items: center;
  gap: 7px;
}

.e2e_view_btn,
.e2e_add_btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px 10px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: .2s ease;
}

.e2e_view_btn {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #2563eb;
}

.e2e_add_btn {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.e2e_view_btn:hover,
.e2e_add_btn:hover {
  transform: translateY(-1px);
  filter: brightness(.96);
}

.e2e_skeleton_row td span {
  display: block;
  height: 15px;
  border-radius: 6px;
  background: linear-gradient(90deg, #edf1f5 25%, #f8fafc 50%, #edf1f5 75%);
  background-size: 200% 100%;
  animation: e2eSkeleton 1.25s infinite linear;
}

.e2e_table_state {
  display: grid;
  justify-items: center;
  padding: 52px 20px;
  text-align: center;
}

.e2e_table_state h4 {
  margin: 14px 0 5px;
  color: #1e293b;
  font-size: 19px;
}

.e2e_table_state p {
  margin: 0 0 15px;
  color: #64748b;
}

.e2e_empty_illustration,
.e2e_state_illustration {
  display: grid;
  width: 72px;
  height: 72px;
  place-items: center;
  border-radius: 50%;
  background: #eff6ff;
  color: #3b82f6;
  font-size: 26px;
}

.e2e_state_illustration {
  background: #fef2f2;
  color: #dc2626;
  font-weight: 900;
}

.e2e_table_pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  color: #64748b;
  font-size: 13px;
}

.e2e_table_pagination > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.e2e_table_pagination button,
.e2e_table_pagination span {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 1px solid #dbe3ef;
  border-radius: 9px;
  background: #fff;
  color: #475569;
}

.e2e_table_pagination span {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
  font-weight: 800;
}

.e2e_table_pagination button:not(:disabled) {
  cursor: pointer;
}

.e2e_table_pagination button:disabled {
  opacity: .4;
}

.e2e_sr_only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes e2eTableFade {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes e2eSkeleton {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

@keyframes e2eSpin {
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .e2e_table_container { padding: 16px; }
  .e2e_table_header,
  .e2e_table_toolbar { align-items: stretch; flex-direction: column; }
  .e2e_table_actions { justify-content: flex-start; }
  .e2e_table_actions button { flex: 1 1 auto; justify-content: center; }
  .e2e_table_limit { justify-content: flex-end; }
  .e2e_table_pagination { gap: 15px; }
}

.e2e_table_status {
  display: inline-flex; align-items: center; gap: 7px; min-width: 92px;
  padding: 6px 10px; border: 1px solid #dbe4f0; border-radius: 999px;
  background: #f8fafc; color: #475569; font-size: 11px; font-weight: 800; line-height: 1;
}
.e2e_table_status i { width: 7px; height: 7px; flex: 0 0 auto; border-radius: 50%; background: currentColor; box-shadow: 0 0 0 3px rgba(100,116,139,.1); }
.e2e_table_status_submitted { border-color: #c7d2fe; background: #eef2ff; color: #4f46e5; }
.e2e_table_status_interview,
.e2e_table_status_interview-scheduled { border-color: #fed7aa; background: #fff7ed; color: #c2410c; }
.e2e_table_status_placed,
.e2e_table_status_active { border-color: #bbf7d0; background: #f0fdf4; color: #15803d; }
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/table.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA,0EAA0E,aAAa,CAAC,yBAAyB,CAAC,YAAY;;AAE9H;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,uBAAuB,aAAa,EAAE;EACtC;uBACqB,oBAAoB,EAAE,sBAAsB,EAAE;EACnE,qBAAqB,2BAA2B,EAAE;EAClD,4BAA4B,cAAc,EAAE,uBAAuB,EAAE;EACrE,mBAAmB,yBAAyB,EAAE;EAC9C,wBAAwB,SAAS,EAAE;AACrC;;AAEA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe;EACpE,iBAAiB,EAAE,yBAAyB,EAAE,oBAAoB;EAClE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACxF;AACA,sBAAsB,UAAU,EAAE,WAAW,EAAE,cAAc,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,0CAA0C,EAAE;AACzJ,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC1F;wCACwC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACpG;2BAC2B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":[".e2e_table_container {\n  margin-top: 25px;\n  padding: 24px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 22px;\n  box-shadow: 0 6px 24px rgba(15, 23, 42, .06);\n  animation: e2eTableFade .3s ease both;\n}\n\n.e2e_table_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 20px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.e2e_table_header h3 {\n  margin: 2px 0 4px;\n  color: #172033;\n  font-size: 25px;\n  font-weight: 800;\n}\n\n.e2e_table_header span,\n.e2e_table_eyebrow {\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.e2e_table_eyebrow {\n  color: #2563eb;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n}\n\n.e2e_table_actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 9px;\n}\n\n.e2e_table_actions button,\n.e2e_table_state button {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 13px;\n  border: 1px solid #dbe3ef;\n  border-radius: 10px;\n  background: #fff;\n  color: #334155;\n  font-weight: 700;\n  cursor: pointer;\n  transition: .2s ease;\n}\n\n.e2e_table_actions button:hover,\n.e2e_table_state button:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n  transform: translateY(-1px);\n}\n\n.e2e_table_actions button:disabled {\n  opacity: .55;\n  cursor: wait;\n}\n\n.e2e_table_toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.e2e_table_search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: min(520px, 100%);\n  padding: 0 14px;\n  border: 1px solid #dbe3ef;\n  border-radius: 12px;\n  color: #64748b;\n  background: #f8fafc;\n}\n\n.e2e_table_search:focus-within {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, .1);\n  background: #fff;\n}\n\n.e2e_table_search input {\n  width: 100%;\n  padding: 12px 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #172033;\n}\n\n.e2e_table_limit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.e2e_table_limit select {\n  padding: 9px;\n  border: 1px solid #dbe3ef;\n  border-radius: 9px;\n  background: #fff;\n}\n\n.e2e_table_loading_label {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 0 0 12px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.e2e_table_loading_label span {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #bfdbfe;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: e2eSpin .75s linear infinite;\n}\n\n.e2e_table_scroll {\n  max-height: 620px;\n  overflow: auto;\n  border: 1px solid #edf1f6;\n  border-radius: 14px;\n  scrollbar-color: #cbd5e1 transparent;\n  scrollbar-width: thin;\n}\n\n.e2e_dashboard_table {\n  width: 100%;\n  min-width: 1100px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.e2e_dashboard_table thead {\n  position: sticky;\n  z-index: 2;\n  top: 0;\n  background: #f5f8fc;\n}\n\n.e2e_dashboard_table th {\n  padding: 14px 16px;\n  border-bottom: 1px solid #dfe7f1;\n  color: #475569;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: .055em;\n  white-space: nowrap;\n}\n\n.e2e_sort_button {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  text-transform: inherit;\n  letter-spacing: inherit;\n  cursor: pointer;\n}\n\n.e2e_sort_button svg {\n  color: #94a3b8;\n}\n\n.e2e_dashboard_table td {\n  max-width: 260px;\n  padding: 15px 16px;\n  border-bottom: 1px solid #eef2f7;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.e2e_candidate_report_link {\n  max-width:100%;\n  padding:0;\n  overflow:hidden;\n  border:0;\n  background:transparent;\n  color:#2563eb;\n  font:inherit;\n  font-weight:800;\n  text-align:left;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  cursor:pointer;\n}\n.e2e_candidate_report_link:hover,.e2e_candidate_report_link:focus-visible{color:#4338ca;text-decoration:underline;outline:none}\n\n.e2e_dashboard_table tbody tr:nth-child(even) {\n  background: #fafcff;\n}\n\n.e2e_dashboard_table tbody tr {\n  transition: background .18s ease, transform .18s ease;\n}\n\n.e2e_dashboard_table tbody tr:hover {\n  background: #eef6ff;\n}\n\n.e2e_action_buttons {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.e2e_view_btn,\n.e2e_add_btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 8px 10px;\n  border-radius: 9px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: .2s ease;\n}\n\n.e2e_view_btn {\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.e2e_add_btn {\n  border: 1px solid #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.e2e_view_btn:hover,\n.e2e_add_btn:hover {\n  transform: translateY(-1px);\n  filter: brightness(.96);\n}\n\n.e2e_skeleton_row td span {\n  display: block;\n  height: 15px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #edf1f5 25%, #f8fafc 50%, #edf1f5 75%);\n  background-size: 200% 100%;\n  animation: e2eSkeleton 1.25s infinite linear;\n}\n\n.e2e_table_state {\n  display: grid;\n  justify-items: center;\n  padding: 52px 20px;\n  text-align: center;\n}\n\n.e2e_table_state h4 {\n  margin: 14px 0 5px;\n  color: #1e293b;\n  font-size: 19px;\n}\n\n.e2e_table_state p {\n  margin: 0 0 15px;\n  color: #64748b;\n}\n\n.e2e_empty_illustration,\n.e2e_state_illustration {\n  display: grid;\n  width: 72px;\n  height: 72px;\n  place-items: center;\n  border-radius: 50%;\n  background: #eff6ff;\n  color: #3b82f6;\n  font-size: 26px;\n}\n\n.e2e_state_illustration {\n  background: #fef2f2;\n  color: #dc2626;\n  font-weight: 900;\n}\n\n.e2e_table_pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 18px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.e2e_table_pagination > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.e2e_table_pagination button,\n.e2e_table_pagination span {\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  border: 1px solid #dbe3ef;\n  border-radius: 9px;\n  background: #fff;\n  color: #475569;\n}\n\n.e2e_table_pagination span {\n  border-color: #2563eb;\n  background: #2563eb;\n  color: #fff;\n  font-weight: 800;\n}\n\n.e2e_table_pagination button:not(:disabled) {\n  cursor: pointer;\n}\n\n.e2e_table_pagination button:disabled {\n  opacity: .4;\n}\n\n.e2e_sr_only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@keyframes e2eTableFade {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes e2eSkeleton {\n  from { background-position: 200% 0; }\n  to { background-position: -200% 0; }\n}\n\n@keyframes e2eSpin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 768px) {\n  .e2e_table_container { padding: 16px; }\n  .e2e_table_header,\n  .e2e_table_toolbar { align-items: stretch; flex-direction: column; }\n  .e2e_table_actions { justify-content: flex-start; }\n  .e2e_table_actions button { flex: 1 1 auto; justify-content: center; }\n  .e2e_table_limit { justify-content: flex-end; }\n  .e2e_table_pagination { gap: 15px; }\n}\n\n.e2e_table_status {\n  display: inline-flex; align-items: center; gap: 7px; min-width: 92px;\n  padding: 6px 10px; border: 1px solid #dbe4f0; border-radius: 999px;\n  background: #f8fafc; color: #475569; font-size: 11px; font-weight: 800; line-height: 1;\n}\n.e2e_table_status i { width: 7px; height: 7px; flex: 0 0 auto; border-radius: 50%; background: currentColor; box-shadow: 0 0 0 3px rgba(100,116,139,.1); }\n.e2e_table_status_submitted { border-color: #c7d2fe; background: #eef2ff; color: #4f46e5; }\n.e2e_table_status_interview,\n.e2e_table_status_interview-scheduled { border-color: #fed7aa; background: #fff7ed; color: #c2410c; }\n.e2e_table_status_placed,\n.e2e_table_status_active { border-color: #bbf7d0; background: #f0fdf4; color: #15803d; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
